var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.055 5a7.063 7.063 0 0 1 5.883 3.133A1 1 0 0 0 19.6 7.02 9.063 9.063 0 0 0 12.054 3C7.061 3 3 7.023 3 12s4.06 9 9.055 9a9.058 9.058 0 0 0 8.367-5.552 1 1 0 0 0-1.845-.77A7.059 7.059 0 0 1 12.055 19C8.152 19 5 15.86 5 12s3.152-7 7.055-7Z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 2a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z","fill":"#fff","key":1})]);
}

Refresh.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Refresh;

Refresh.default = Refresh;
